import { Injectable } from '@angular/core';
import {OrganizationState, UserProfileState} from 'remarketing-angular-library';
import {AnalyticsService} from 'smartauction-frontend-micro-library';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class PostingAnalyticsHelperService {

  constructor(private readonly store: Store,
    private readonly analyticsService: AnalyticsService) { }

  sendPageloadAnalyticsEvent(tenantName, postingType, postingFormName) {
    try {
      this.analyticsService.trackPageLoad({
        page: {
          pageName: `${tenantName}:Sell:${postingType}:${postingFormName}`,
          attributes: {
            userData: {
              oeName: this.store.selectSnapshot(OrganizationState.oeName),
              oeUuid: this.store.selectSnapshot(OrganizationState.oeUuid),
              internalId: this.store.selectSnapshot(OrganizationState.internalId),
              userId: this.store.selectSnapshot(UserProfileState.userId),
              userUuid: this.store.selectSnapshot(UserProfileState.userUuid)
            }
          }
        }
      });
    } catch(e) {
      console.error(e);
    }
  }

  trackModalView(modalName) {
    try {
      this.analyticsService.track('modalView', modalName);
    } catch(e) {
      console.error(e);
    }
  }

  trackMultiErrorModal(errorList) {
    try {
      this.analyticsService.track('customError', 'multiError', errorList);
    } catch(e) {
      console.error(e);
    }
  }

  trackCustomError(errorMessage){
    try {
      this.analyticsService.track('customError', errorMessage);
    } catch(e) {
      console.error(e);
    }
  }

  trackPriceChangeEvent(eventName, originalPrice, updatedPrice){
    try {
      this.analyticsService.track('customEvent',
        {
          name: eventName,
          attr: {
            originalPrice: originalPrice,
            updatedPrice: updatedPrice
          }
        });
    } catch(e) {
      console.error(e);
    }
  }

  trackPostSuccess(eventName, vin){
    try {
      this.analyticsService.track('customEvent',
        {
          name: eventName,
          attr: {
            vin: vin
          }
        });
    } catch(e) {
      console.error(e);
    }
  }
}
